(async () => {
  'use strict';
  const gate = document.getElementById('ae-global-entry-gate');
  if (!gate) return;
  const url = new URL(window.location.href);
  const force = url.searchParams.get('ae_entry') === '1';
  let choice = gate.dataset.choice;
  if (force) {
    try {
      const cartUrl = gate.dataset.cartUrl || '/cart';
      await fetch(cartUrl.replace(/\/$/, '') + '/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({attributes: {ae_shopping_mode: ''}})
      });
    } catch (_) {}
    choice = '';
    gate.dataset.choice = '';
    try { window.sessionStorage.removeItem('ae_global_entry_choice'); } catch (_) {}
  }
  const explicitLocaleMatch = url.pathname.match(/^\/(en|tr|de|it)(?:-[a-z]{2})?(?=\/|$)/i); const explicitLocale = explicitLocaleMatch ? explicitLocaleMatch[1].toLowerCase() : ''; const explicitEnglish = explicitLocale === 'en';
  let visitorCountry = gate.dataset.country;
  if (!explicitEnglish && choice !== 'wholesale' && gate.dataset.designMode !== 'true' && !/^\/(customer_authentication|account)(\/|$)/.test(url.pathname)) {
    try {
      const cachedCountry = window.sessionStorage.getItem('ae_detected_country');
      if (cachedCountry) visitorCountry = cachedCountry;
      else {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + 'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=false', {
          credentials: 'same-origin', signal: AbortSignal.timeout(4000)
        });
        if (response.ok) {
          const result = await response.json();
          visitorCountry = result.detected_values?.country?.handle || visitorCountry;
          if (visitorCountry) window.sessionStorage.setItem('ae_detected_country', visitorCountry);
        }
      }
    } catch (_) {}
  }
  const international = visitorCountry && visitorCountry !== 'TR';
  const desiredLocale = explicitLocale || (explicitEnglish || international || choice === 'wholesale' || gate.dataset.b2b === 'true' ? 'en' : 'tr');
  const desiredCountry = choice === 'wholesale' && gate.dataset.country === 'TR'
    ? 'US'
    : (!explicitEnglish && visitorCountry === 'TR' && choice !== 'wholesale'
      ? 'TR'
      : gate.dataset.country);
  const marketLanguageForm = document.querySelector('form input[name="language_code"][value="' + desiredLocale + '"]')?.form;
  const preserveExplicitTranslation = (explicitLocale === 'de' || explicitLocale === 'it') && gate.dataset.locale === explicitLocale;
  if (!preserveExplicitTranslation && (gate.dataset.locale !== desiredLocale || gate.dataset.country !== desiredCountry) && gate.dataset.designMode !== 'true' && marketLanguageForm && !/^\/(customer_authentication|account)(\/|$)/.test(url.pathname)) {
    const returnInput = marketLanguageForm.querySelector('[name="return_to"]');
    const returnPath = desiredLocale === 'tr' ? url.pathname.replace(/^\/en(?:-[a-z]{2})?(?=\/|$)/i, '') || '/' : url.pathname;
    if (returnInput) returnInput.value = returnPath + url.search + url.hash;
    if (gate.dataset.country !== desiredCountry) {
      let countryInput = marketLanguageForm.querySelector('[name="country_code"]');
      if (!countryInput) {
        countryInput = document.createElement('input');
        countryInput.type = 'hidden';
        countryInput.name = 'country_code';
        marketLanguageForm.appendChild(countryInput);
      }
      countryInput.value = desiredCountry;
    }
    marketLanguageForm.submit();
    return;
  }
  if (gate.dataset.skip === 'true' || (!force && (choice === 'retail' || choice === 'wholesale'))) {
    gate.remove();
    return;
  }
  gate.style.display = 'flex';
  Array.from(document.body.children).forEach(element => {
    if (element !== gate) element.inert = true;
  });
  const overflow = document.body.style.overflow;
  document.body.style.overflow = 'hidden';
  let saving = false;
  const controls = Array.from(gate.querySelectorAll('.ae-entry-hotspot'));
  controls[0]?.focus();
  gate.addEventListener('keydown', event => {
    if (event.key !== 'Tab') return;
    event.preventDefault();
    const current = controls.indexOf(document.activeElement);
    const next = (current + (event.shiftKey ? -1 : 1) + controls.length) % controls.length;
    controls[next]?.focus();
  });
  const error = gate.querySelector('.ae-entry-error');

  async function choose(mode, target) {
    if (saving) return;
    saving = true;
    gate.setAttribute('aria-busy', 'true');
    controls.forEach(control => {
      control.setAttribute('aria-disabled', 'true');
      if (control.tagName === 'BUTTON') control.disabled = true;
    });
    if (error) error.hidden = true;
    try {
      const cartUrl = gate.dataset.cartUrl || '/cart';
      const response = await fetch(cartUrl.replace(/\/$/, '') + '/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({attributes: {ae_shopping_mode: mode}})
      });
      if (!response.ok) throw new Error('choice-save-failed');
      const cart = await response.json();
      if (cart.attributes?.ae_shopping_mode !== mode) throw new Error('choice-not-saved');
      try {window.sessionStorage.setItem('ae_global_entry_choice', mode);} catch (_) {}
      document.body.style.overflow = overflow;
      const destination = new URL(target || window.location.href, window.location.origin);
      destination.searchParams.delete('ae_entry');
      if (url.searchParams.has('preview_theme_id')) {
        destination.searchParams.set('preview_theme_id', url.searchParams.get('preview_theme_id'));
      }
      const languageForm = document.querySelector('form input[name="language_code"][value="' + (explicitLocale || 'en') + '"]')?.form;
      if (mode === 'wholesale' && languageForm) {
        const returnInput = languageForm.querySelector('[name="return_to"]');
        if (returnInput) returnInput.value = destination.pathname + destination.search;
        languageForm.submit();
      } else {
        window.location.assign(destination.href);
      }
    } catch (_) {
      saving = false;
      gate.removeAttribute('aria-busy');
      controls.forEach(control => {
        control.removeAttribute('aria-disabled');
        if (control.tagName === 'BUTTON') control.disabled = false;
      });
      if (error) {
        error.textContent = gate.dataset.saveError;
        error.hidden = false;
      }
    }
  }

  gate.querySelector('.ae-entry-retail')?.addEventListener('click', () => choose('retail'));
  gate.querySelector('.ae-entry-wholesale')?.addEventListener('click', event => {
    event.preventDefault();
    choose('wholesale', event.currentTarget.href);
  });
})();
